// extracted by mini-css-extract-plugin
export default {"dashboard":"DashBoard_dashboard__FCpov","sidebar":"DashBoard_sidebar__gfS3U","outlet":"DashBoard_outlet__0IVBu"};